module.exports = __webpack_public_path__ + "static/img/match.dcbf46fe.svg";